<template>
  <div>
    <page-header
      title="Receivables"
      breadcrumb="Billings & Collections > Receivables"
    />
    <section class="bg-white my-4 p-3">
      <div class="flex border-b-2 border-gray-400 pt-2">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'private' }"
          @click="currentTab = 'private'"
        >
          <p>Private</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'corporate' }"
          @click="currentTab = 'corporate'"
        >
          <p>Corporate</p>
        </div>
      </div>

      <div class="flex py-4 justify-between">
        <div class="unit-point">
          <p class="w-full">Transaction Count: {{ totalRecievables }}</p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
        <div class="unit-point">
          <p class="w-full">
            Total Value: ₦
            {{
              recievableProperty.toalTransactionValue
                ? recievableProperty.toalTransactionValue.toLocaleString()
                : "N/A"
            }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>

      <TableFilter @setQueryparams="sortItemProps" />
      <div v-loading="loading"><TableRecievables 
        :recievables="allRecievables"
        /></div>
      <PaginationControl
        :total="totalRecievables"
        :pageNumber="sortOptions.pageNumber"
        @pageNumber="setPageDisplaySettlement"
        @pageSize="setNumDisplaySettlement"
      />
    </section>
  </div>
</template>

<script>
import moment from "moment";
import TableFilter from "../modules/TableFilter.vue";
import TableRecievables from "../modules/TableRecievables.vue";
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/pagination";

export default {
  data() {
    return {
      currentTab: "private",
      totalRecievables: null,
      loading: true,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        startDate: null,
        endDate: null,
        searchString: "",
      },
      allRecievables: [],
      recievableProperty: {},
    };
  },
  watch: {
    sortOptions() {
      this.getAllRecievables();
    },
    currentTab() {
      this.getAllRecievables();
    },
  },
  mounted() {
    this.getAllRecievables();
  },
  computed: {
    payload() {
      return {
        pageSize: this.sortOptions.pageSize,
        pageNumber: this.sortOptions.pageNumber,
        type: this.currentTab,
        searchTerm: this.sortOptions.searchString,
        status: "recievable",
        startDate:
          this.sortOptions.startDate != null
            ? moment(this.sortOptions.startDate).format("YYYY-MM-DD")
            : "",
        endDate:
          this.sortOptions.endDate != null
            ? moment(this.sortOptions.endDate).format("YYYY-MM-DD")
            : "",
      };
    },
  },
  components: {
    TableFilter,
    TableRecievables,
    PageHeader,
    PaginationControl,
  },
  methods: {
    setNumDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageSize: val };
    },
    setPageDisplaySettlement(val) {
      this.sortOptions = { ...this.sortOptions, pageNumber: val };
    },
    sortItemProps(val) {
      this.sortOptions = { ...this.sortOptions, ...val };
    },
    async getAllRecievables() {
      this.loading = true;
      try {
        let response = await this.$_getTransaction(this.payload);

        this.allRecievables = response.data.data.shippings

        this.recievableProperty = response.data.data;
        this.totalRecievables = response.data.data.totalCount;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
.unit-point {
  @apply flex shadow-xl px-4 py-4 rounded-lg items-center;
  width: 47%;
}
</style>
